import { AppRoutes } from "@/shared/lib/routes"
import { createRoute } from "@tanstack/react-router"
import { useEffect } from "react"
import { rootRoute } from "./__root"
import { ANALYTICS_EVENTS, trackEvent } from "@/features/analytics"
import { useAuthStore } from "@/stores/auth-store"
import { usePurchaseStore } from "@/stores/purchase-store"
import { MobileLayout } from "@/shared/components/mobile-layout"

export const successRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: AppRoutes.SUCCESS,
  component: SuccessPage,
})

function SuccessPage() {
  const user = useAuthStore((s) => s.user)
  const purchaseStatus = usePurchaseStore((s) => s.status)
  const planId = usePurchaseStore((s) => s.planId)

  useEffect(() => {
    trackEvent(ANALYTICS_EVENTS.SUCCESS_PAGE_VIEWED, {
      userId: user?.uid,
      productId: planId ?? undefined,
    })
  }, [user, planId])

  return (
    <div className="flex min-h-[100dvh] items-center justify-center bg-background">
      <MobileLayout className="text-center">
        <div className="space-y-6 py-12">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-green-100">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" className="text-green-600">
              <path
                d="M5 13L9 17L19 7"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>

          <div>
            <h1 className="text-2xl font-bold">You're all set!</h1>
            <p className="mt-2 text-muted-foreground">
              {user
                ? `Welcome, ${user.displayName || user.email || "there"}!`
                : "Your purchase is complete."}
            </p>
            {purchaseStatus === "success" && (
              <p className="mt-1 text-sm text-muted-foreground">Your plan is now active.</p>
            )}
          </div>

          <div className="rounded-xl border border-border bg-card p-6">
            <p className="text-sm text-muted-foreground">
              This is your success page. Replace this content with your app's dashboard, onboarding,
              or next steps.
            </p>
          </div>
        </div>
      </MobileLayout>
    </div>
  )
}
